<script setup>
import PlatformBadge from './PlatformBadge.vue';

defineProps({
  engagement: {
    type: Object,
    default: () => ({
      topPosts: [],
      averages: { likes: 0, comments: 0, shares: 0 },
    }),
  },
});

const truncate = (str, n = 120) =>
  str && str.length > n ? `${str.slice(0, n)}…` : str || '';
</script>

<template>
  <div class="rounded-xl border border-n-weak bg-n-background p-4">
    <div class="mb-3 flex items-center justify-between">
      <h3 class="text-sm font-semibold text-n-slate-12">
        Top Posts (Engajamento)
      </h3>
      <div class="flex gap-3 text-xs text-n-slate-11">
        <span>♥ {{ Math.round(engagement.averages.likes) }}</span>
        <span>💬 {{ Math.round(engagement.averages.comments) }}</span>
        <span>↗ {{ Math.round(engagement.averages.shares) }}</span>
      </div>
    </div>
    <div class="space-y-2">
      <div
        v-if="!engagement.topPosts.length"
        class="py-6 text-center text-sm text-n-slate-11"
      >
        Nenhum post coletado.
      </div>
      <a
        v-for="post in engagement.topPosts"
        :key="post.id"
        :href="post.postUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="block rounded-lg border border-n-weak p-3 transition hover:bg-n-slate-2"
      >
        <div class="flex items-start justify-between gap-3">
          <div class="min-w-0 flex-1">
            <div class="mb-1 flex items-center gap-2">
              <span class="text-xs font-semibold text-n-slate-12">{{
                post.authorName
              }}</span>
              <PlatformBadge :platform="post.platform" size="xs" />
            </div>
            <p class="text-xs text-n-slate-11">{{ truncate(post.content) }}</p>
          </div>
          <div
            class="flex shrink-0 flex-col items-end text-[11px] text-n-slate-11"
          >
            <span>♥ {{ post.likes }}</span>
            <span>💬 {{ post.comments }}</span>
            <span>↗ {{ post.shares }}</span>
          </div>
        </div>
      </a>
    </div>
  </div>
</template>
